<template style='height：100%'>
  <div class="box">
    <el-container>
      <el-header>
        <headerList></headerList>
      </el-header>
      <el-main>
        <div class="content">
          <div class="title">用户注册</div>
          <div class="form-box">
            <div class="form-list">
              <div class="list-left">
                <img :src="require('@/assets/image/user.png')" alt="" />
              </div>
              <div class="list-right">
                <input type="text" v-model="form.username"  placeholder="请设置用户名称" />
              </div>
            </div>
            <div class="form-list">
              <div class="list-left">
                <img :src="require('@/assets/image/name.png')" alt="" />
              </div>
              <div class="list-right">
                <input type="text" v-model="form.fullName" placeholder="请输入真实姓名" />
              </div>
            </div>

            <div class="form-list">
              <div class="list-left">
                <img :src="require('@/assets/image/phone.png')" alt="" />
              </div>
              <div class="list-right">
                <input  v-model="form.phone" placeholder="请输入手机号" />
                 <!-- <el-input v-model="form.phone" ></el-input> -->
              </div>
            </div>
            <div class="form-list">
              <div class="list-left">
                <img :src="require('@/assets/image/password.png')" alt="" />
              </div>
              <div class="list-right">
                <input type="password" v-model="form.passwordFirst" placeholder="请再次输入登录密码" />
              </div>
            </div>
            <div class="form-list">
              <div class="list-left">
                <img :src="require('@/assets/image/password.png')" alt="" />
              </div>
              <div class="list-right">
                <input type="password" v-model="form.passwordSecond" placeholder="请再次输入登录密码" />
              </div>
            </div>
            <div class="form-list">
              <div class="list-left">
                <img :src="require('@/assets/image/local.png')" alt="" />
              </div>
              <div class="list-right">
                <!--                <input type="text" v-model="form.city" placeholder="请输入城市" />-->
                <template>
                  <el-select  ref="proLabel" v-model="form.zoneId" placeholder="请选择">
                    <el-option
                            v-for="item in form.area"
                            :key="item.id"
                            :label="item.cityName"
                            :value="item.id">
                    </el-option>
                  </el-select>
                </template>
              </div>
            </div>
            <div class="form-list">
              <div class="list-left">
                <img :src="require('@/assets/image/pin.png')" alt="" />
              </div>
              <div class="list-right">
                <input class="code" v-model="form.code" type="text" placeholder="输入验证码" />
                <el-image
                  :src="captchaImg"
                  class="captchaImg"
                  @click="getCaptcha"
                ></el-image>
              </div>
            </div>

          </div>
          <el-button class="register" type="warning" @click="register(form)" round>注册</el-button>
          <div class="login" @click="jump()">已有账号，立即登录</div>
        </div>
        <div class="left-pic">
          <img :src="require('@/assets/image/tree.png')" alt="" />
        </div>
        <div class="right-pic">
          <img :src="require('@/assets/image/people.png')" alt="" />
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import headerList from "./public/header";

export default {
  name: "registered",
  components: { headerList },
  data() {
    return {
      form: {
        username: "",
        phone: "",
        code: "",
        fullName:"",
        city:"",
        passwordFirst:"",
        passwordSecond:"",
        password:"",
        token:"",
        area:[]
      },
      captchaImg: null,
    };
  },
  created() {
    this.getCaptcha();
    this.getCity();
  },
  methods: {
    onSubmit() {
    },
    getCity(){
      this.$axios
              .get("/gw/zone/list", {
                params: {

                },
              })
              .then((res) => {
                console.log(res)
                this.form.area = res.data.data;
              });
    },
    getCaptcha() {
      this.$axios.get("/captcha").then((res) => {
         this.form.token = res.data.data.token;
         this.captchaImg = res.data.data.captchaImg;
         this.form.code = "";
      })
    },
    register(form) {
      let nameRag = /^[a-z0-9_-]{6,16}$/;//用户名校验
      let phoneRag = /^[1][3,4,5,7,8][0-9]{9}$/;//手机号校验
      let pswRag = /^[A-Za-z0-9_-]{6,18}$/;//密码校验
      if(!nameRag.test(form.username)){
           this.$message.error('请输入正确的用户名，至少六位，不能输入中文');
            return;
      }
      if(!phoneRag.test(form.phone)){
           this.$message.error('请输入正确的手机号');
            return;
      }
       if(!pswRag.test(form.passwordFirst)){
           this.$message.error('密码设置不正确，最少6位，包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符');
            return;
      }
      if(form.passwordFirst !=form.passwordSecond){
          this.$message.error('两次密码不一致，请重新输入');
            return;
      }
      if(form.code ==''){
          this.$message.error('请输入验证码');
            return;
      }
      form.city = this.$refs.proLabel.selected.label;
    form.password = form.passwordSecond;
      this.$axios.post("gw/sys/user/receptionSave", form).then((res) => {
        if(res.status == 200){
            this.$message(res.data.msg)
             this.$router.push("/");
        }else{
           this.$message.error(res.data.msg)
        }
      }).catch(error =>
       this.getCaptcha()
      );
    },
    jump(){
      this.$router.push("/webLogin");
    }
  },
};
</script>
<style scoped>
.box {
  position: relative;
  top: 0;
  left: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: url("../assets/image/background.jpg") no-repeat;
  background-size: 100% 100%;
}
.el-container {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}
.el-header {
  width: 100%;
  height: 7.1875rem /* 115px -> 7.1875rem */ !important;
  line-height: 7.1875rem /* 115px -> 7.1875rem */;
  background-color: #fff;
  color: #333;
  text-align: center;
  position: fixed;
  background: rgba(255, 255, 255, 0.8);
  top: 0;
  left: 0;
  z-index: 99;
}
.el-main {
  color: #333;
  padding: 0;
  width: 100%;
}
.content {
  width: 49.6875rem /* 795px -> 49.6875rem */;
  height: 50rem /* 800px -> 50rem */;
  background: #fff;
  opacity: 0.7;
  margin: 8.1875rem /* 131px -> 8.1875rem */ auto;
  position: relative;
  top: 0;
  left: 0;
}
.left-pic {
  width: 8.8125rem /* 141px -> 8.8125rem */;
  height: 14.1875rem /* 227px -> 14.1875rem */;
  position: absolute;
  bottom: 7.125rem /* 114px -> 7.125rem */;
  left: 28.625rem /* 458px -> 28.625rem */;
}
.right-pic {
  width: 15.125rem /* 242px -> 15.125rem */;
  height: 12.9375rem /* 207px -> 12.9375rem */;
  position: absolute;
  bottom: 7.125rem /* 114px -> 7.125rem */;
  right: 23.375rem /* 374px -> 23.375rem */;
}
.title {
  width: 8.5625rem /* 137px -> 8.5625rem */;
  height: 9.125rem /* 146px -> 9.125rem */;
  margin: 0 auto;
  font-size: 2rem /* 32px -> 2rem */;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #f78100;
  line-height: 9.125rem /* 146px -> 9.125rem */;
}
a {
  text-decoration: none;
}
.form-box {
  width: 28.75rem /* 460px -> 28.75rem */;
  height: 20rem /* 320px -> 20rem */;
  margin: 0 auto;
}
.form-list {
  margin-top: 1.25rem /* 20px -> 1.25rem */;
  height: 3.125rem /* 50px -> 3.125rem */;
  border-bottom: 2px solid #c1b8af;
}
.list-left {
  float: left;
  width: 6.25rem /* 100px -> 6.25rem */;
  height: 3.125rem /* 50px -> 3.125rem */;
}
.list-left img {
  margin: .625rem /* 10px -> .625rem */ 2.1875rem /* 35px -> 2.1875rem */;
}
.list-right {
  float: left;
  width: 22.5rem /* 360px -> 22.5rem */;
}
.list-right input {
  border: none;
  height: 3.125rem /* 50px -> 3.125rem */;
  font-size: 1.5rem /* 24px -> 1.5rem */;
  width: 100%;
  outline: none;
  background: none;
}
.list-right .code {
  width: 60%;
}
.register {
  width: 28.75rem /* 460px -> 28.75rem */;
  height: 3.75rem /* 60px -> 3.75rem */;
  font-size: 1.5rem /* 24px -> 1.5rem */;
  background: #e73e10;
  border-radius: 1.875rem /* 30px -> 1.875rem */;
  margin: .625rem /* 10px -> .625rem */ 10.4375rem /* 167px -> 10.4375rem */;
}
.login {
  width: 9.0625rem /* 145px -> 9.0625rem */;
  height: 1.0625rem /* 17px -> 1.0625rem */;
  font-size: 1rem /* 16px -> 1rem */;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-decoration: underline;
  color: #f78000;
  margin: .625rem /* 10px -> .625rem */ 20.3125rem /* 325px -> 20.3125rem */;
  cursor:pointer;
}
</style>
